import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const sectionStyle = css`
  margin-bottom: var(--space-250);
  ${breakpoints.from.desktop} {
    margin: var(--space-300) 0;
  }
`;
